import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const QuestionDisplay = ({ gameTitle, country }) => {
  return (
    <Paper
      elevation={5}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto 0.5rem auto",
        width: { xs: "95%", md: "70%", lg: "60%" },
        minHeight: { xs: 200, sm: 300, md: 350 },
        backgroundColor: "background.default",
      }}
    >
      {gameTitle === "Flags" ? (
        <Box
          component="img"
          sx={{
            maxHeight: { xs: 150, sm: 250, md: 300 },
            maxWidth: { xs: 200, sm: 300, md: 350, lg: 450 },
          }}
          src={country.flag}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box component="img" height="75px" src={country.flag} />
          <Typography
            variant="h4"
            sx={{ textAlign: "center", fontSize: { sm: "32px", md: "40px" } }}
          >
            {country.name}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default QuestionDisplay;
